import { useCallback } from 'react';

/**
 * A hook that creates an onKeyDown handler for handling Enter key presses.
 * @param callback - The function to execute when Enter key is pressed
 * @returns An onKeyDown handler function
 */
export const useEnterKeyHandler = (
  callback: () => void
): ((e: React.KeyboardEvent<HTMLInputElement>) => void) => {
  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>): void => {
      if (e.key === 'Enter') {
        callback();
      }
    },
    [callback]
  );

  return onKeyDown;
};
